<nav
  class="container"
  role="navigation"
  [attr.aria-label]="
    'accessibility.shared.pagination.nav_aria_label'
      | translate: { numberOfPages: totalPageCount }
  ">
  <ng-container *ngIf="totalPageCount > 1 || showDisabledNavigationButtons">
    <button
      class="previous-arrow-button button-reset focus-link"
      role="button"
      [class.arrow-button-disabled]="atFirstPage"
      [attr.disabled]="atFirstPage ? true : null"
      [attr.aria-label]="
        'accessibility.shared.pagination.previous_page' | translate
      "
      (click)="changePage(currentPage - 1)">
      <rd-shared-icon
        class="flex h-4 w-4 rotate-180 transform p-0.5"
        [iconOptions]="flippableIconOptions"
        [iconSymbol]="'icon-pagination-right'"
        [iconTheme]="atFirstPage ? 'disabled' : 'link'"></rd-shared-icon>
    </button>
  </ng-container>

  <!-- Page numbers -->

  <ul class="number-container mx-2 my-0 flex items-center">
    <li class="flex h-full items-center">
      <button
        class="page button-reset h-6 w-6 focus-link"
        [class.page-active]="isSelectedPage(1)"
        role="button"
        (click)="changePage(1)"
        [attr.aria-current]="isSelectedPage(1) ? 'true' : null"
        [attr.disabled]="isSelectedPage(1) ? 'true' : null"
        [attr.aria-label]="
          'accessibility.shared.pagination.go_to_first_page' | translate
        ">
        1
      </button>
    </li>
    <div
      class="page left-ellipsis h-6 w-6"
      *ngIf="shouldShowLeftEllipsis()"
      aria-hidden="true">
      ...
    </div>
    <li class="flex h-full items-center" *ngFor="let item of numberOfPageArray">
      <button
        class="page button-reset h-6 w-6 focus-link"
        [class.page-active]="isSelectedPage(item)"
        role="button"
        (click)="changePage(item)"
        [attr.aria-current]="isSelectedPage(item) ? 'true' : null"
        [attr.disabled]="isSelectedPage(item) ? 'true' : null"
        [attr.aria-label]="
          'accessibility.shared.pagination.go_to_page'
            | translate: { pageNumber: item, numberOfPages: totalPageCount }
        ">
        {{ item }}
      </button>
    </li>
    <div
      class="page right-ellipsis h-6 w-6"
      *ngIf="shouldShowRightEllipsis()"
      aria-hidden="true">
      ...
    </div>
    <li class="flex h-full items-center">
      <button
        class="page button-reset h-6 w-6 focus-link"
        [class.page-active]="isSelectedPage(totalPageCount)"
        role="button"
        *ngIf="totalPageCount !== 1"
        (click)="changePage(totalPageCount)"
        [attr.aria-current]="isSelectedPage(totalPageCount) ? 'true' : null"
        [attr.disabled]="isSelectedPage(totalPageCount) ? 'true' : null"
        [attr.aria-label]="
          'accessibility.shared.pagination.go_to_last_page' | translate
        ">
        {{ totalPageCount }}
      </button>
    </li>
  </ul>

  <!-- Right arrow -->
  <ng-container *ngIf="totalPageCount !== 1 || showDisabledNavigationButtons">
    <button
      class="next-arrow-button button-reset focus-link"
      role="button"
      [class.arrow-button-disabled]="atLastPage"
      [attr.disabled]="atLastPage ? true : null"
      [attr.aria-label]="
        'accessibility.shared.pagination.next_page' | translate
      "
      (click)="changePage(currentPage + 1)">
      <rd-shared-icon
        class="flex h-4 w-4 p-0.5"
        [iconOptions]="flippableIconOptions"
        [iconSymbol]="'icon-pagination-right'"
        [iconTheme]="atLastPage ? 'disabled' : 'link'"></rd-shared-icon>
    </button>
  </ng-container>
</nav>
